module.exports = __webpack_public_path__ + "img/blanton.427708e8.png";